"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Type guard to determine if an object has a given key
// If this feature gets implemented, we can use `in` instead: https://github.com/Microsoft/TypeScript/issues/10485

function hasKey(k, o) {
  return typeof o === 'object' && k in o;
}

exports.hasKey = hasKey;